import { formatCNPJ } from './cnpj-utils';

export const phoneMask = (value: any) => {
    if (!value) return '';

    return value
        .replaceAll(/\D/g, '')
        .replaceAll(/^(\d{2})(\d)/g, '($1) $2')
        .replace(/(\d)(\d{4})$/, '$1-$2');
};

export const cnpjMask = (value: any) => {
    return formatCNPJ(value);
};
